import React from 'react';
import i18n from 'i18next';
import Typography from '@mui/material/Typography';

export default function CountryPicker({
  country,
  options,
  onCountrySelected,
}) {
  return (
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column',
    }}
    >
      <Typography id="transition-modal-title" variant="h6" component="h2">

        <span>{i18n.t('select_country')}</span>
      </Typography>

      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '20px',
        gap: '15px',
      }}
      >
        {
        options.map((option) => {
          const CountryFlag = option.label;
          return (
            <button
              key={option.value}
              type="button"
              style={{
                boxShadow: option.value === country ? '0 0 10px 5px #009c39' : 'none',
                display: 'flex',
                justifyContent: 'stretch',
                alignItems: 'stretch',
                width: 'calc((100% - 45px) / 4)',
                padding: '0px',
                border: 'none',
                backgroundColor: 'transparent',
              }}
              onClick={() => onCountrySelected(option.value)}
            >
              <CountryFlag style={{ width: '100%' }} />
            </button>
          );
        })
        }
      </div>
    </div>
  );
}
